import PropTypes from 'prop-types'; // ใช้กำหนดชนิดค่า ใน props เช่นtitle ต้องเป็นสตริง amount ต้องเป็นตัวเลข
import './Item.css'


const Item = (props) => {
  const{title,amount}=props
  const status = amount<0 ?"expense":"income"
  const symbol = amount<0 ?"-":"+"
  const formatNumber=(num)=> {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

  return (
    <li className={status}>{title}<span> {symbol}{formatNumber(Math.abs(amount))}</span>
  
    </li>
   
  );
};
//กำหนดให้ props ของ item มีชนิดข้อมูลเป็นอะไรโดยใช้ Libraly Proptypes
Item.propTypes={
  title:PropTypes.string.isRequired,
  amount:PropTypes.number.isRequired
}
export default Item;
